// extracted by mini-css-extract-plugin
export var content = "zNmdxGjW4TSiuEkZqIMe";
export var info = "Xissy4Wff3h8258DKZiN";
export var link = "cMicyMwvm9k5T3x5q7hb";
export var negative = "uYpZ6jKjW5ZHVPkCcqlt";
export var neutral = "uw4URDVOJJHcUyo9pWfE";
export var positive = "EjoHk2Ae67HH10Bf3QRX";
export var primary = "OATCCflsIdDjZsIRZC2Q";
export var root = "YegbYS9DiN5SjIDa37BI";
export var secondary = "WpP9CIUTfenirudEugUI";
export var sideItem = "K4Vd4WA2EIv58fXQ6o5V";
export var warning = "fDIv4JdlRXFUKSdnwr4M";